import { iconMenu } from '../../../../globals/assets';

export default {
  wrapper: {
    position: 'absolute',
    top: '18px',
    left: '8px',
    padding: '5px',
    borderRadius: '50%',
    cursor: 'pointer',
    zIndex: 10,
  },
  icon: {
    backgroundImage: `url("${iconMenu}")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '16px',
    height: '16px',
    width: '16px',
  },
};
